import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { Heading } from '../components_catalyst/heading';
import { Text } from '../components_catalyst/text';

export function SupportPage() {
  useDocumentTitle('Support');

  return (
    <div className="max-w-2xl mx-auto p-6">
      <Heading level={1} className="mb-6">
        Early Alpha Support
      </Heading>

      <div className="space-y-4">
        <Text>Thanks so much for trying out MilestoneMap.org!</Text>

        <Text>
          MilestoneMap.org support systems are a work in progress. For now please contact{' '}
          <a
            href="mailto:info@30to80.com?subject=SUPPORT"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            info@30to80.com
          </a>{' '}
          and include SUPPORT at the beginning of the subject line.
        </Text>
        <Text>Looking forward to your message!</Text>
      </div>
    </div>
  );
}
